import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/contracts/salesMapping/initialState.salesMapping.data';
import {
  searchProductCodeName as searchProductCodeNameAPI,
  fetchServiceLevelName as fetchServiceLevelNameAPI,
  deleteOrderable as deleteOrderableAPI,
  saveOrderable as saveOrderableAPI,
  fetchOrderableData as fetchOrderableDataAPI,
  fetchOrderableCompareData as fetchOrderableCompareDataAPI,
  fetchSupportedZone as fetchSupportedZoneAPI,
  fetchSupported as fetchSupportedAPI,
  fetchSupportedOverride as fetchSupportedOverrideAPI,
  deleteSupported as deleteSupportedAPI,
  searchUnsupportedReport as searchUnsupportedReportAPI,
  searchSalesOrderReport as searchSalesOrderReportAPI,
  searchHigherSalesOrderReport as searchHigherSalesOrderReportAPI,
  searchSalesOrder as searchSalesOrderAPI,
  addUnsupportedSales as addUnsupportedSalesAPI,
  deleteUnsupported as deleteUnsupportedAPI,
  saveSalesOrderHOCReport as saveSalesOrderHOCReportAPI,
} from '../../../../apis/contractsAPI';

import {
  ACTIONS_SALES_MAPPING_ORDERABLE_TAB,
  ACTIONS_SALES_MAPPING_SUPPORTED_TAB,
  ACTION_SALES_MAPPING_UNSUPPORTED_TAB,
  ACTION_SALES_MAPPING_SALES_ORDER_TAB,
} from '../../../../constants/actionCreator';
import { SALES_MAPPING_DATA, API_RESPONSE_STATUS } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { v4 as uuidv4 } from 'uuid';
import { globalDateFormat } from '../../../../utils/common';
// API Call Functions orderable tab

export const searchProductCodeNameData = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_ORDERABLE_TAB.SEARCH_PRODUCT_CODE_NAME,
  searchProductCodeNameAPI
);

export const fetchServiceLevelNameData = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_ORDERABLE_TAB.FETCH_SERVICE_LEVEL_NAME,
  fetchServiceLevelNameAPI
);

export const deleteOrderableData = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_ORDERABLE_TAB.DELETE_ORDERABLE,
  deleteOrderableAPI
);

export const saveOrderableData = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_ORDERABLE_TAB.SAVE_ORDERABLE,
  saveOrderableAPI
);

export const fetchOrderableData = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_ORDERABLE_TAB.FETCH_ORDERABLE_DATA,
  fetchOrderableDataAPI
);

export const fetchOrderableCompareData = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_ORDERABLE_TAB.FETCH_ORDERABLE_COMPARE_DATA,
  fetchOrderableCompareDataAPI
);

// API Call Functions supported tab

export const fetchSupportedZone = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_SUPPORTED_TAB.FETCH_SUPPORTED_ZONE,
  fetchSupportedZoneAPI
);

export const fetchSupported = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_SUPPORTED_TAB.FETCH_SUPPORTED,
  fetchSupportedAPI
);

export const fetchSupportedOverride = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_SUPPORTED_TAB.FETCH_OVERRIDE,
  fetchSupportedOverrideAPI
);
export const deleteSupported = createAsyncThunkWrapper(
  ACTIONS_SALES_MAPPING_SUPPORTED_TAB.DELETE_SUPPORTED,
  deleteSupportedAPI
);

//unsupported
export const serachUnsupportedReport = createAsyncThunkWrapper(
  ACTION_SALES_MAPPING_UNSUPPORTED_TAB.SEARCH_UNSUPPORTED_REPORT,
  searchUnsupportedReportAPI
);

export const searchSalesOrder = createAsyncThunkWrapper(
  ACTION_SALES_MAPPING_UNSUPPORTED_TAB.SEARCH_SALES_ORDER,
  searchSalesOrderAPI
);

export const addUnsupportedSales = createAsyncThunkWrapper(
  ACTION_SALES_MAPPING_UNSUPPORTED_TAB.ADD_UNSUPPORTED_SALES,
  addUnsupportedSalesAPI
);

export const deleteUnsupported = createAsyncThunkWrapper(
  ACTION_SALES_MAPPING_UNSUPPORTED_TAB.DELETE_UNSUPPORTED_SALES,
  deleteUnsupportedAPI
);

//sales order
export const searchSalesOrderReport = createAsyncThunkWrapper(
  ACTION_SALES_MAPPING_SALES_ORDER_TAB.SEARCH_SALES_ORDER_REPORT,
  searchSalesOrderReportAPI
);
export const searchHigherSalesOrderReport = createAsyncThunkWrapper(
  ACTION_SALES_MAPPING_SALES_ORDER_TAB.SEARCH_HIGHER_SALES_ORDER_REPORT,
  searchHigherSalesOrderReportAPI
);

export const saveHOCReport = createAsyncThunkWrapper(
  ACTION_SALES_MAPPING_SALES_ORDER_TAB.SAVE_SALES_ORDER_HOC_REPORT,
  saveSalesOrderHOCReportAPI
)

// Reducer and Actions
const salesMappingSlice = createSlice({
  name: 'salesMapping',
  initialState,
  reducers: {
    setOpenServiceProductModal: (state) => {
      state.openServiceProductModal = true;
    },

    setCloseServiceProductModal: (state) => {
      state.openServiceProductModal = false;
    },

    resetSalesMappingTab: () => initialState,

    resetOrderableAPI: (state) => {
      state.orderable = initialState.orderable;
    },

    setCode: (state, action) => {
      state.orderable.codeField = action.payload;
    },

    setName: (state, action) => {
      state.orderable.nameField = action.payload;
    },

    setServiceProduct: (state, action) => {
      state.orderable.serviceProductField = action.payload;
    },

    handleLevelFormFields: (state, action) => {
      state.orderable.serviceLevelId = action.payload.value;
    },

    handlesetSelectedTabValue: (state, action) => {
      state.selectededTabValue = action.payload;
    },
    resetModalFields: (state) => {
      state.orderable.codeField = '';
      state.orderable.nameField = '';
      state.orderable.searchProductCodeNameResult = '';
    },

    setServiceModalData: (state, action) => {
      const {
        id,
        erpServiceProductId,
        serviceProductCode,
        serviceProductName,
      } = action.payload;
      state.orderable.serviceModalData = {
        ...state.orderable.serviceModalData,
        id,
        erpServiceProductId,
        serviceProductCode,
        serviceProductName,
      };
    },

    setServiceLevelDropdownData: (state, action) => {
      const { servicePriceLevelId, serviceOfferingName } = action.payload;
      state.orderable.serviceLevelDropdownData = {
        ...state.orderable.serviceLevelDropdownData,
        servicePriceLevelId,
        serviceOfferingName,
      };
    },

    setOrderableGridObject: (state, action) => {
      const {
        contractId,
        erpServiceProductId,
        serviceProductCode,
        serviceProductName,
        servicePriceLevelId,
        serviceOfferingName,
        lastModifiedUserId,
        lastModifiedTimestamp,
      } = action.payload;
      state.orderable.orderableGridObject = {
        ...state.orderable.orderableGridObject,
        contractId,
        erpServiceProductId,
        serviceProductCode,
        serviceProductName,
        servicePriceLevelId,
        serviceOfferingName,
        lastModifiedUserId,
        lastModifiedTimestamp,
      };
    },

    setGridData: (state, action) => {
      state.orderable.isSet = true;
      state.orderable.gridData = action.payload;
    },

    updateGridData: (state, action) => {
      state.orderable.fetchOrderableResult = action.payload;
    },

    resetInputs: (state) => {
      state.orderable.serviceProductField = '';
      state.orderable.serviceLevelId = 0;
    },
    grandparentGridDataSet: (state, action) => {
      state.orderable.grandparentGridData = action.payload;
    },

    //supported
    openProductsModal: (state) => {
      state.openSupportedModal = true;
    },

    closeProductsModal: (state) => {
      state.openSupportedModal = false;
    },

    setProduct: (state, action) => {
      state.orderable.productField = action.payload;
    },

    setModalData: (state, action) => {
      const { erpProductId, productCode, productName } = action.payload;
      state.supported.modalData = {
        ...state.supported.modalData,
        erpProductId,
        productCode,
        productName,
      };
    },

    rowsSet: (state, action) => {
      state.supported.selectedRows = action.payload;
    },

    overrideSet: (state, action) => {
      state.supported.isOverride = action?.payload;
    },
    setSupportedRequestBody: (state, action) => {
      state.supported.requestBody[action.payload.name] = action.payload.value;
    },
    resetSupportedValues: (state) => {
      state.supported = initialState.supported;
    },
    //unsupported
    filterUnsupportedGridData: (state, action) => {
      state.unsupported.data = action.payload;
    },
    filterSalesOrderData: (state, action) => {
      if (action.payload.type === SALES_MAPPING_DATA.CONTRACT) {
        state.salesOrder.salesOrderReportData = action.payload.data;
      } else {
        state.salesOrder.higherSalesOrderReportData = action.payload.data;
      }
    },
    setUnsupportedRequestBody: (state, action) => {
      state.unsupported.requestBody[action.payload.name] = action.payload.value;
    },
    resetUnsupportedValues: (state) => {
      state.unsupported = initialState.unsupported;
    },
    setSalesOrderRequestBody: (state, action) => {
      state.salesOrder.requestBody[action.payload.name] = action.payload.value;
    },
    filterAllData: (state) => {
      state.salesOrder.higherSalesOrderReportData =state.salesOrder.higherSalesOrderReportData?.map((item)=>
      {
        item.isDeleted = true;
        return item;
      });
      state.isDataEdited = 'salesOrder';
    },
    salesOrderReset: (state) => {
      state.salesOrder = initialState.salesOrder;
    },
    setOpenSalesProductModal: (state) => {
      state.unsupported.openSalesProductModal = true;
    },
    setCloseSalesProductModal: (state) => {
      state.unsupported.openSalesProductModal = false;
    },
    resetSalesModalFields: (state) => {
      state.unsupported.salesCode = '';
      state.unsupported.salesName = '';
      state.unsupported.searchData = '';
    },
    setSalesCode: (state, action) => {
      state.unsupported.salesCode = action?.payload;
    },
    setSalesName: (state, action) => {
      state.unsupported.salesName = action?.payload;
    },
    setIsDataFoundUnsupported: (state, action) => {
      state.unsupported.isDataFoundUnsupported = action?.payload;
    },
    setalertAdd: (state, action) => {
      state.unsupported.alertAdd = action?.payload;
    },
    deleteDataSet: (state, action) => {
      state.unsupported.deleteData = action?.payload;
    },
    inputErrorDeleteSet: (state, action) => {
      state.unsupported.inputErrorDelete = action?.payload;
    },
    handleisDataEdited: (state, action) => {
      state.isDataEdited = action?.payload;
    },
    handleNoDataToSave: (state, action) => {
      state.noDataToSave = action?.payload;
    },
    setHOCSaveResponse:(state)=>{
      state.hocSaveResponse = null;
    },
    deleteHigherOrderContract:(state,action)=>{
      state.salesOrder.higherSalesOrderReportData =  state.salesOrder.higherSalesOrderReportData?.map((item)=>{
      if(item?.erpSalesOrderItemId === action.payload)
        {
          item.isDeleted = true;
        } 
        return item;
      })
      state.isDataEdited = 'salesOrder';
    },
    handleIsOk: (state, action) => {
      state.isOk = action?.payload;
    },
    handleDeleteAlert: (state, action) => {
      state.deleteAlert = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //orderable
      .addCase(searchProductCodeNameData.pending, (state) => {
        state.orderable.searchProductCodeNameLoading = true;
      })
      .addCase(searchProductCodeNameData.fulfilled, (state, action) => {
        state.orderable.searchProductCodeNameLoading = false;
        state.orderable.searchProductCodeNameResult = action?.payload
          ? action?.payload
          : [];
      })

      .addCase(searchProductCodeNameData.rejected, (state, action) => {
        state.orderable.searchProductCodeNameLoading = false;
        state.orderable.searchProductCodeNameResult = action?.payload;
      })

      .addCase(fetchServiceLevelNameData.pending, (state) => {
        state.orderable.fetchServiceLevelNameLoading = true;
      })
      .addCase(fetchServiceLevelNameData.fulfilled, (state, action) => {
        state.orderable.fetchServiceLevelNameLoading = false;
        state.orderable.fetchServiceLevelNameResult = action?.payload;
      })
      .addCase(fetchServiceLevelNameData.rejected, (state, action) => {
        state.orderable.fetchServiceLevelNameLoading = false;
        state.orderable.fetchServiceLevelNameResult = action?.payload;
      })

      .addCase(deleteOrderableData.pending, (state) => {
        state.orderable.deleteOrderableLoading = true;
      })
      .addCase(deleteOrderableData.fulfilled, (state, action) => {
        state.orderable.deleteOrderableLoading = false;
        state.orderable.deleteOrderableResult = action?.payload;
      })
      .addCase(deleteOrderableData.rejected, (state, action) => {
        state.orderable.deleteOrderableLoading = false;
        state.orderable.deleteOrderableResult = action?.payload;
      })

      .addCase(saveOrderableData.pending, (state) => {
        state.orderable.saveOrderableLoading = true;
        state.orderable.apiResponseStatus = API_RESPONSE_STATUS.pending;
      })
      .addCase(saveOrderableData.fulfilled, (state, action) => {
        state.orderable.saveOrderableLoading = false;
        state.orderable.saveOrderableResult = action?.payload;
        if (action.payload === true) {
          state.orderable.apiResponseStatus = API_RESPONSE_STATUS.success;
        } else if (action.payload === false) {
          state.orderable.apiResponseStatus = API_RESPONSE_STATUS.fail;
        }
      })
      .addCase(saveOrderableData.rejected, (state, action) => {
        state.orderable.saveOrderableLoading = false;
        state.orderable.saveOrderableResult = action.payload;
        state.orderable.apiResponseStatus = API_RESPONSE_STATUS.fail;
      })

      .addCase(fetchOrderableData.pending, (state) => {
        state.orderable.fetchOrderableLoading = true;
      })
      .addCase(fetchOrderableData.fulfilled, (state, action) => {
        state.orderable.fetchOrderableLoading = false;
        let result = action?.payload?.contractOrderable?.map((item) => ({
          ...item,
          id: uuidv4(),
        }));
        state.orderable.fetchOrderableResult = result;
        state.orderable.totalCount = action?.payload?.totalRecords;
      })
      .addCase(fetchOrderableData.rejected, (state, action) => {
        state.orderable.fetchOrderableLoading = false;
        state.orderable.fetchOrderableResult = action?.payload;
      })

      .addCase(fetchOrderableCompareData.pending, (state) => {
        state.orderable.fetchOrderableCompareLoading = true;
      })
      .addCase(fetchOrderableCompareData.fulfilled, (state, action) => {
        state.orderable.fetchOrderableCompareLoading = false;
        let result = action?.payload?.contractOrderable?.map((item) => ({
          ...item,
          id: uuidv4(),
        }));
        state.orderable.fetchOrderableCompareResult = result;
        state.orderable.totalCompareCount = action?.payload?.totalRecords;
      })
      .addCase(fetchOrderableCompareData.rejected, (state, action) => {
        state.orderable.fetchOrderableCompareLoading = false;
        state.orderable.fetchOrderableCompareResult = action?.payload;
      })

      //supported
      .addCase(fetchSupportedZone.pending, (state) => {
        state.supported.fetchSupportedZoneLoading = true;
        state.supported.fetchSupportedZoneResult = [];
        state.supported.isZoneFound = false;
      })
      .addCase(fetchSupportedZone.fulfilled, (state, action) => {
        let result = action?.payload?.map((item) => ({
          ...item,
          id: uuidv4(),
        }));
        state.supported.fetchSupportedZoneLoading = false;
        state.supported.fetchSupportedZoneResult = result || [];
        if (result?.length > 0) {
          state.supported.isZoneFound = true;
        }
      })

      .addCase(fetchSupportedZone.rejected, (state) => {
        state.supported.fetchSupportedZoneLoading = false;
        state.supported.fetchSupportedZoneResult = [];
        state.supported.isZoneFound = false;
      })

      .addCase(fetchSupported.pending, (state) => {
        state.supported.fetchSupportedLoading = true;
        state.supported.fetchSupportedResult =[];
      })
      .addCase(fetchSupported.fulfilled, (state, action) => {
        state.supported.fetchSupportedLoading = false;
        state.supported.fetchSupportedResult =
          action?.payload?.supportedContractList;
        state.supported.totalCount = action?.payload?.totalRecords;
      })
      .addCase(fetchSupported.rejected, (state) => {
        state.supported.fetchSupportedLoading = false;
        state.supported.fetchSupportedResult = [];
      })

      .addCase(fetchSupportedOverride.pending, (state) => {
        state.supported.fetchOverrideLoading = true;
      })
      .addCase(fetchSupportedOverride.fulfilled, (state, action) => {
        state.supported.fetchOverrideLoading = false;
        state.supported.overrideData = action?.payload;
      })
      .addCase(fetchSupportedOverride.rejected, (state) => {
        state.supported.fetchOverrideLoading = false;
        state.supported.overrideData = [];
      })
      
      .addCase(deleteSupported.pending, (state) => {
        state.supported.deleteLoading = true;
        state.supported.deleteData = false;
        state.supported.deleteResponse='pending';
      })
      .addCase(deleteSupported.fulfilled, (state, action) => {
        state.supported.deleteLoading = false;
        state.supported.deleteData = action?.payload;
        state.supported.deleteResponse='success';
       
      })
      .addCase(deleteSupported.rejected, (state) => {
        state.supported.deleteLoading = false;
        state.supported.deleteData = false;
        state.supported.deleteResponse='error';
      })

      //Unsupported
      .addCase(serachUnsupportedReport.pending, (state) => {
        state.unsupported.loading = true;
        state.unsupported.inputError = null;
        state.unsupported.isDataFound = false;
      })
      .addCase(serachUnsupportedReport.fulfilled, (state, action) => {
        state.unsupported.loading = false;
        state.unsupported.data = action?.payload ? action?.payload : [];
        state.unsupported.isDataFound = true;
      })
      .addCase(serachUnsupportedReport.rejected, (state) => {
        state.unsupported.loading = false;
        state.unsupported.data = [];
        state.unsupported.isDataFound = true;
      })

      .addCase(searchSalesOrder.pending, (state) => {
        state.unsupported.loadingSalesOrder = true;
        state.unsupported.inputErrorSearchingSalesOrder = null;
        state.unsupported.isDataFoundSalesOrder = false;
      })
      .addCase(searchSalesOrder.fulfilled, (state, action) => {
        state.unsupported.loadingSalesOrder = false;
        state.unsupported.searchData = action.payload?.associateSalesProduct;
        state.unsupported.total = action?.payload?.totalRecords;
        state.unsupported.isDataFoundSalesOrder = true;
      })
      .addCase(searchSalesOrder.rejected, (state) => {
        state.unsupported.loadingSalesOrder = false;
        state.unsupported.searchData = [];
        state.unsupported.isDataFoundSalesOrder = true;
      })

      .addCase(addUnsupportedSales.pending, (state) => {
        state.unsupported.addUnsupportedloading = true;
        state.unsupported.inputErrorAddUnsupported = null;
        state.unsupported.alertAdd = API_RESPONSE_STATUS.pending;
        state.unsupported.isDataFoundUnsupported = false;
      })
      .addCase(addUnsupportedSales.fulfilled, (state, action) => {
        state.unsupported.addUnsupportedloading = false;
        state.unsupported.addUnsupportedData = action?.payload
          ? action?.payload
          : '';
        if (action?.payload) {
          state.unsupported.isDataFoundUnsupported = true;
          state.unsupported.alertAdd = API_RESPONSE_STATUS.success;
        }
        if (
          state.unsupported.addUnsupportedData == '' &&
          action?.payload == ''
        ) {
          state.unsupported.isDataFoundUnsupported = false;
          state.unsupported.alertAdd = API_RESPONSE_STATUS.fail;
        }
      })
      .addCase(addUnsupportedSales.rejected, (state) => {
        state.unsupported.addUnsupportedloading = false;
        state.unsupported.addUnsupportedData = [];
        state.unsupported.alertAdd = API_RESPONSE_STATUS.fail;
        state.unsupported.isDataFoundUnsupported = true;
      })
      .addCase(deleteUnsupported.pending, (state) => {
        state.unsupported.loadingDelete = true;
        state.unsupported.inputErrorDelete = null;
        state.unsupported.isDataFoundDelete = false;
      })
      .addCase(deleteUnsupported.fulfilled, (state) => {
        state.unsupported.loadingDelete = false;
        state.unsupported.deleteData = 'Product successfully deleted';
        state.unsupported.isDataFoundDelete = true;
      })
      .addCase(deleteUnsupported.rejected, (state) => {
        state.unsupported.loadingDelete = false;
        state.unsupported.inputErrorDelete =
          'Something went wrong with transaction execution';
        state.unsupported.isDataFoundDelete = false;
      })

      .addCase(searchSalesOrderReport.pending, (state) => {
        state.salesOrder.loading = true;
        state.salesOrder.inputError = null;
        state.salesOrder.isDataFound = false;
        state.salesOrder.totalSales = 0;
      })
      .addCase(searchSalesOrderReport.fulfilled, (state, action) => {
        state.salesOrder.loading = false;
        state.salesOrder.salesOrderReportData =
          action?.payload?.salesOrderContractList?.map((item) => ({
            ...item,
            typeOfContract: 'contract',
            shipDate: item?.shipDate ? globalDateFormat(item?.shipDate) : '',
          }));
        state.salesOrder.totalSales = action?.payload?.totalRecords
          ? action?.payload?.totalRecords
          : 0;
        state.salesOrder.isDataFound = true;
      })
      .addCase(searchSalesOrderReport.rejected, (state, action) => {
        state.salesOrder.loading = false;
        state.salesOrder.inputError = action.payload;
        state.salesOrder.isDataFound = false;
        state.salesOrder.totalSales = 0;
      })

      .addCase(searchHigherSalesOrderReport.pending, (state) => {
        state.salesOrder.higherOrderLoading = true;
        state.salesOrder.higerOrderInpurtError = null;
        state.salesOrder.isHigherOrderDataFound = false;
        state.salesOrder.totalHigher = 0;
        state.salesOrder.higherSalesOrderReportData = [];
      })
      .addCase(searchHigherSalesOrderReport.fulfilled, (state, action) => {
        state.salesOrder.higherOrderLoading = false;
        state.salesOrder.higherSalesOrderReportData =
          action?.payload?.salesOrderContractList?.map((item) => ({
            ...item,
            shipDate: item?.shipDate,
            formatedDate: item?.shipDate ? globalDateFormat(item?.shipDate) : '',
            isDeleted: false
          }));
        state.salesOrder.isHigherOrderDataFound = true;
        state.salesOrder.totalHigher = action?.payload?.totalRecords
          ? action?.payload?.totalRecords
          : 0;
      })
      .addCase(saveHOCReport.pending, (state) => {
        state.salesOrder.hocSaveResponse = null;
      })

      .addCase(saveHOCReport.fulfilled, (state, action) => {
        state.salesOrder.hocSaveResponse = action?.payload;
       
      })
      .addCase(saveHOCReport.rejected, (state) => {
        state.salesOrder.hocSaveResponse = false; 
      });
  },
});

export const {
  setUnsupportedRequestBody,
  resetValues,
  setOpenServiceProductModal,
  setCloseServiceProductModal,
  setCode,
  setName,
  setServiceProduct,
  handleLevelFormFields,
  resetModalFields,
  setOrderableGridObject,
  setGridData,
  setServiceModalData,
  setServiceLevelDropdownData,
  updateGridData,
  openProductsModal,
  closeProductsModal,
  setProduct,
  setModalData,
  grandparentGridDataSet,
  filterUnsupportedGridData,
  resetUnsupportedValues,
  resetInputs,
  handlesetSelectedTabValue,
  setSalesOrderRequestBody,
  filterSalesOrderData,
  filterAllData,
  salesOrderReset,
  resetSalesMappingTab,
  rowsSet,
  overrideSet,
  setSupportedRequestBody,
  resetSupportedValues,
  setOpenSalesProductModal,
  setCloseSalesProductModal,
  resetSalesModalFields,
  setSalesCode,
  setSalesName,
  setIsDataFoundUnsupported,
  setalertAdd,
  deleteDataSet,
  inputErrorDeleteSet,
  handleisDataEdited,
  handleNoDataToSave,
  deleteHigherOrderContract,
  setHOCSaveResponse,
  handleIsOk,
  handleDeleteAlert,
  resetOrderableAPI,
} = salesMappingSlice.actions;
export default salesMappingSlice.reducer;
